import api from './api';

export const expenseService = {
  // Fetch expenses list with filters and P&L summary
  getExpenses: async (params = {}) => {
    const response = await api.get('/expenses', { params });
    return response.data;
  },

  // Fetch single expense by ID
  getExpense: async (id) => {
    const response = await api.get(`/expenses/${id}`);
    return response.data;
  },

  // Create new expense / income entry
  createExpense: async (data) => {
    const response = await api.post('/expenses', data);
    return response.data;
  },

  // Update existing expense entry
  updateExpense: async (id, data) => {
    const response = await api.put(`/expenses/${id}`, data);
    return response.data;
  },

  // Delete expense entry
  deleteExpense: async (id) => {
    const response = await api.delete(`/expenses/${id}`);
    return response.data;
  },
};
